import React, { useEffect, useRef, useState } from "react";

export const SectionBorder = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const borderRef = useRef(null);

  // Fix typo from "opicity" to "opacity"
  const opacityStyle = {
    opacity: 1,
    borderBottom: "1.2px solid",
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after visibility
        }
      },
      { threshold: 0.1 } // Trigger when 10% is visible
    );

    if (borderRef.current) {
      observer.observe(borderRef.current);
    }

    return () => {
      if (borderRef.current) {
        observer.unobserve(borderRef.current);
      }
    };
  }, []);

  return (
    <div className="w-full">
      <style>
        {`
          @keyframes widthIncrease {
            from {
              width: 10%;
            }
            to {
              width: 100%;
            }
          }

          .animated-border {
            height: 1px; /* Adjust height as needed */
            background-color: black; /* Change this if you want a different color */
            transition: width 0.5s; /* Optional: smooth transition */
          }

          .animated {
            animation: widthIncrease 2s forwards; /* Adjust duration as needed */
          }
        `}
      </style>

      <div
        ref={borderRef}
        className={`${
          props.className === "bg-red" ? "border-black-500" : "border-black-900"
        } my-0 w-full animated-border ${
          isVisible ? "animated" : ""
        }`}
        style={opacityStyle}
      ></div>
    </div>
  );
};
